import { Routes } from '@angular/router';
import { AuthGuard, AuthLogoutGuard, RouterTools } from '@sol/components';
import { LabErrorPageComponent } from './components/lab-error-page/lab-error-page.component';
import { PlaygroundRouteId } from './models/playground-route-id';

export const routes: Routes = [
  RouterTools.ofRedirect(PlaygroundRouteId.app_playground, PlaygroundRouteId.home),
  RouterTools.ofLazy(PlaygroundRouteId.home, () =>
    import('./pages/home/home-page.component').then(m => m.HomePageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.colors, () =>
    import('./pages/colors/colors-page.component').then(m => m.ColorsPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.moodboard, () =>
    import('./pages/moodboard/moodboard-page.component').then(m => m.MoodboardPageComponent),
  ),
  RouterTools.ofRedirect(PlaygroundRouteId.account_preferences, PlaygroundRouteId.home),
  RouterTools.ofRedirect(PlaygroundRouteId.mode_light, PlaygroundRouteId.home),
  RouterTools.ofRedirect(PlaygroundRouteId.mode_dark, PlaygroundRouteId.home),
  RouterTools.ofRedirect(PlaygroundRouteId.mode_night, PlaygroundRouteId.home),
  RouterTools.ofRedirect(PlaygroundRouteId.mode_high_contrast, PlaygroundRouteId.home),
  RouterTools.ofLazy(PlaygroundRouteId.workbench, () =>
    import('./pages/workbench/workbench-page.component').then(m => m.WorkbenchPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.variant, () =>
    import('./pages/variant/variant-page.component').then(m => m.VariantPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.forbidden, () =>
    import('./pages/forbidden/forbidden-page.component').then(m => m.ForbiddenPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.button_group, () =>
    import('./pages/button-group/button-group-page.component').then(m => m.ButtonGroupPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.new_table, () =>
    import('./pages/new-table/new-table-page.component').then(m => m.NewTablePageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.accordion, () =>
    import('./pages/accordion/accordion-page.component').then(m => m.AccordionPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.action_bar, () =>
    import('./pages/action-bar/action-bar-page.component').then(m => m.ActionBarPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.alert, () =>
    import('./pages/alert/alert-page.component').then(m => m.AlertPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.badge, () =>
    import('./pages/badge/badge-page.component').then(m => m.BadgePageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.big_checkbox, () =>
    import('./pages/big-checkbox/big-checkbox-page.component').then(m => m.BigCheckboxPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.big_radiobutton, () =>
    import('./pages/big-radiobutton/big-radiobutton-page.component').then(m => m.BigRadiobuttonPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.budget, () =>
    import('./pages/budget/budget-page.component').then(m => m.BudgetPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.button, () =>
    import('./pages/button/button-page.component').then(m => m.ButtonPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.card, () =>
    import('./pages/card/card-page.component').then(m => m.CardPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.chart, () =>
    import('./pages/chart/chart-page.component').then(m => m.ChartPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.checkbox, () =>
    import('./pages/checkbox/checkbox-page.component').then(m => m.CheckboxPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.collapsible, () =>
    import('./pages/collapsible/collapsible-page.component').then(m => m.CollapsiblePageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.dashboard_card, () =>
    import('./pages/dashboard-card/dashboard-card-page.component').then(m => m.DashboardCardPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.details_panel, () =>
    import('./pages/details-panel/details-panel-page.component').then(m => m.DetailsPanelPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.divider, () =>
    import('./pages/divider/divider-page.component').then(m => m.DividerPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.empty_state, () =>
    import('./pages/empty-state/empty-state-page.component').then(m => m.EmptyStatePageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.error_page, () =>
    import('./pages/error-page/error-page-page.component').then(m => m.ErrorPagePageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.file_upload, () =>
    import('./pages/file-upload/file-upload-page.component').then(m => m.FileUploadPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.icon, () =>
    import('./pages/icon/icon-page.component').then(m => m.IconPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.image, () =>
    import('./pages/image/image-page.component').then(m => m.ImagePageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.layout, () =>
    import('./pages/layout/layout-page.component').then(m => m.LayoutPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.loader, () =>
    import('./pages/loader/loader-page.component').then(m => m.LoaderPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.metric, () =>
    import('./pages/metric/metric-page.component').then(m => m.MetricPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.log, () =>
    import('./pages/log/log-page.component').then(m => m.LogPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.log_step, () =>
    import('./pages/log-step/log-step-page.component').then(m => m.LogStepPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.navbar, () =>
    import('./pages/navbar/navbar-page.component').then(m => m.NavbarPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.navbar_item, () =>
    import('./pages/navbar-item/navbar-item-page.component').then(m => m.NavbarItemPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.option, () =>
    import('./pages/option/option-page.component').then(m => m.OptionPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.paginator, () =>
    import('./pages/paginator/paginator-page.component').then(m => m.PaginatorPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.query_field, () =>
    import('./pages/query-field/query-field-page.component').then(m => m.QueryFieldPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.radiobutton, () =>
    import('./pages/radiobutton/radiobutton-page.component').then(m => m.RadiobuttonPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.scroll_view, () =>
    import('./pages/scroll-view/scroll-view-page.component').then(m => m.ScrollViewPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.search_field, () =>
    import('./pages/search-field/search-field-page.component').then(m => m.SearchFieldPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.select, () =>
    import('./pages/select/select-page.component').then(m => m.SelectPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.select_content, () =>
    import('./pages/select-content/select-content-page.component').then(m => m.SelectContentPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.severity_tag, () =>
    import('./pages/severity-tag/severity-tag-page.component').then(m => m.SeverityTagPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.severity_box, () =>
    import('./pages/severity-box/severity-box-page.component').then(m => m.SeverityBoxPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.slider, () =>
    import('./pages/slider/slider-page.component').then(m => m.SliderPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.shortcut, () =>
    import('./pages/shortcut/shortcut-page.component').then(m => m.ShortcutPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.smart_select, () =>
    import('./pages/smart-select/smart-select-page.component').then(m => m.SmartSelectPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.smart_select_content, () =>
    import('./pages/smart-select-content/smart-select-content-page.component').then(
      m => m.SmartSelectContentPageComponent,
    ),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.snippet, () =>
    import('./pages/snippet/snippet-page.component').then(m => m.SnippetPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.spinner, () =>
    import('./pages/spinner/spinner-page.component').then(m => m.SpinnerPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.steps, () =>
    import('./pages/steps/steps-page.component').then(m => m.StepsPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.switch, () =>
    import('./pages/switch/switch-page.component').then(m => m.SwitchPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.table, () =>
    import('./pages/table/table-page.component').then(m => m.TablePageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.tag, () =>
    import('./pages/tag/tag-page.component').then(m => m.TagPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.tag_field, () =>
    import('./pages/tag-field/tag-field-page.component').then(m => m.TagFieldPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.text_area, () =>
    import('./pages/text-area/text-area-page.component').then(m => m.TextAreaPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.text_box, () =>
    import('./pages/text-box/text-box-page.component').then(m => m.TextBoxPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.text_field, () =>
    import('./pages/text-field/text-field-page.component').then(m => m.TextFieldPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.tooltip, () =>
    import('./pages/tooltip/tooltip-page.component').then(m => m.TooltipPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.tooltips, () =>
    import('./pages/tooltips/tooltips-page.component').then(m => m.TooltipsPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.trend_tag, () =>
    import('./pages/trend-tag/trend-tag-page.component').then(m => m.TrendTagPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.view_box, () =>
    import('./pages/view-box/view-box-page.component').then(m => m.ViewBoxPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.tabs, () =>
    import('./pages/tabs/tabs-page.component').then(m => m.TabsPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.breadcrumbs, () =>
    import('./pages/breadcrumbs/breadcrumbs-page.component').then(m => m.BreadcrumbsPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.progress_bar, () =>
    import('./pages/progress-bar/progress-bar-page.component').then(m => m.ProgressBarPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.status_tag, () =>
    import('./pages/status-tag/status-tag-page.component').then(m => m.StatusTagPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.toggle_chip, () =>
    import('./pages/toggle-chip/toggle-chip-page.component').then(m => m.ToggleChipPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.toggle_chip_group, () =>
    import('./pages/toggle-chip-group/toggle-chip-group-page.component').then(m => m.ToggleChipGroupPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.toggle_button, () =>
    import('./pages/toggle-button/toggle-button-page.component').then(m => m.ToggleButtonPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.banner, () =>
    import('./pages/banner/banner-page.component').then(m => m.BannerPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.avatar, () =>
    import('./pages/avatar/avatar-page.component').then(m => m.AvatarPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.popover_menu_content, () =>
    import('./pages/popover-menu-content/popover-menu-content-page.component').then(
      m => m.PopoverMenuContentPageComponent,
    ),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.popover_menu_item, () =>
    import('./pages/popover-menu-item/popover-menu-item-page.component').then(m => m.PopoverMenuItemPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.popover_menu_header, () =>
    import('./pages/popover-menu-header/popover-menu-header-page.component').then(
      m => m.PopoverMenuHeaderPageComponent,
    ),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.popover_menu_label, () =>
    import('./pages/popover-menu-label/popover-menu-label-page.component').then(m => m.PopoverMenuLabelPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.form_field, () =>
    import('./pages/form-field/form-field-page.component').then(m => m.FormFieldPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.labeled_row, () =>
    import('./pages/labeled-row/labeled-row-page.component').then(m => m.LabeledRowPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.radio_reveal, () =>
    import('./pages/radio-reveal/radio-reveal-page.component').then(m => m.RadioRevealPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.null_controller, () =>
    import('./pages/null-controller/null-controller-page.component').then(m => m.NullControllerPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.dynamic_fields, () =>
    import('./pages/dynamic-fields/dynamic-fields-page.component').then(m => m.DynamicFieldsPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.prototype_bar, () =>
    import('./pages/prototype-bar/prototype-bar-page.component').then(m => m.PrototypeBarPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.date_field, () =>
    import('./pages/date-field/date-field-page.component').then(m => m.DateFieldPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.date_span_field, () =>
    import('./pages/date-span-field/date-span-field-page.component').then(m => m.DateSpanFieldPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.popover, () =>
    import('./pages/popover/popover-page.component').then(m => m.PopoverPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.popovers, () =>
    import('./pages/popovers/popovers-page.component').then(m => m.PopoversPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.dialogs, () =>
    import('./pages/dialogs/dialogs-page.component').then(m => m.DialogsPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.notification, () =>
    import('./pages/notification/notification-page.component').then(m => m.NotificationPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.confirm_dialog, () =>
    import('./pages/confirm-dialog/confirm-dialog-page.component').then(m => m.ConfirmDialogPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.context_dialog, () =>
    import('./pages/context-dialog/context-dialog-page.component').then(m => m.ContextDialogPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.info_dialog, () =>
    import('./pages/info-dialog/info-dialog-page.component').then(m => m.InfoDialogPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.query_element, () =>
    import('./pages/query-element/query-element-page.component').then(m => m.QueryElementPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.query_field_quick_filter, () =>
    import('./pages/query-field-quick-filter/query-field-quick-filter-page.component').then(
      m => m.QueryFieldQuickFilterPageComponent,
    ),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.tag_list, () =>
    import('./pages/tag-list/tag-list-page.component').then(m => m.TagListPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.number_field, () =>
    import('./pages/number-field/number-field-page.component').then(m => m.NumberFieldPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.time_field, () =>
    import('./pages/time-field/time-field-page.component').then(m => m.TimeFieldPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.tag_field_content, () =>
    import('./pages/tag-field-content/tag-field-content-page.component').then(m => m.TagFieldContentPageComponent),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.tag_field_create_dialog, () =>
    import('./pages/tag-field-create-dialog/tag-field-create-dialog-page.component').then(
      m => m.TagFieldCreateDialogPageComponent,
    ),
  ),

  RouterTools.ofLazy(PlaygroundRouteId.validation_messages, () =>
    import('./pages/validation-messages/validation-messages-page.component').then(
      m => m.ValidationMessagesPageComponent,
    ),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.date_field_content, () =>
    import('./pages/date-field-content/date-field-content-page.component').then(m => m.DateFieldContentPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.sso_button, () =>
    import('./pages/sso-button/sso-button-page.component').then(m => m.SsoButtonPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.code_field, () =>
    import('./pages/code-field/code-field-page.component').then(m => m.CodeFieldPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.qr_code, () =>
    import('./pages/qr-code/qr-code-page.component').then(m => m.QrCodePageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.secret_display, () =>
    import('./pages/secret-display/secret-display-page.component').then(m => m.SecretDisplayPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.chat_message, () =>
    import('./pages/chat-message/chat-message-page.component').then(m => m.ChatMessagePageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.chat_thread, () =>
    import('./pages/chat-thread/chat-thread-page.component').then(m => m.ChatThreadPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.fullscreen_dialog, () =>
    import('./pages/fullscreen-dialog/fullscreen-dialog-page.component').then(m => m.FullscreenDialogPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.tree_view, () =>
    import('./pages/tree-view/tree-view-page.component').then(m => m.TreeViewPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.list_view, () =>
    import('./pages/list-view/list-view-page.component').then(m => m.ListViewPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.toolbar, () =>
    import('./pages/toolbar/toolbar-page.component').then(m => m.ToolbarPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.color_picker, () =>
    import('./pages/color-picker/color-picker-page.component').then(m => m.ColorPickerPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.color_picker_dialog, () =>
    import('./pages/color-picker-dialog/color-picker-dialog-page.component').then(
      m => m.ColorPickerDialogPageComponent,
    ),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.range_slider, () =>
    import('./pages/range-slider/range-slider-page.component').then(m => m.RangeSliderPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.calendar, () =>
    import('./pages/calendar/calendar-page.component').then(m => m.CalendarPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.hierarchical_select, () =>
    import('./pages/hierarchical-select/hierarchical-select-page.component').then(
      m => m.HierarchicalSelectPageComponent,
    ),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.transfer_list, () =>
    import('./pages/transfer-list/transfer-list-page.component').then(m => m.TransferListPageComponent),
  ),
  RouterTools.ofLazy(PlaygroundRouteId.inline_loading, () =>
    import('./pages/inline-loading/inline-loading-page.component').then(m => m.InlineLoadingPageComponent),
  ),
  // Logout — runs the auth guards, which end the Keycloak session and block activation.
  {
    path: 'logout',
    canActivate: [AuthGuard, AuthLogoutGuard],
    component: LabErrorPageComponent,
    data: {
      id: PlaygroundRouteId.account_logout,
    },
  },
];
